import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import ListPres from '../presentational/ListPres';
import { selectMessage, deleteMessages, changeSortOrder, switchView } from '../state/messagingActions';
import { dashboardSelectMessage, dashboardStoreSelectedMessageId } from 'src/ui/features/Dashboard/state/dashboardActions';
import { refreshUnReadMessage } from 'src/new-ui/features/NewDashboard/state/newDashboardAction.js';
import { toggleDrawer } from 'src/utils/utilsActions';
import {
  getMessages,
  getFilters,
  getMeta,
  checkIsDraftView,
  checkIsComposeView,
  isRequestLoading,
} from 'src/ui/features/Messaging/state/messagingReselect';
import { withSnackbar } from 'notistack';
import { resetFilterLoader, resetMessageLoader } from 'src/ui/features/Messaging/state/messagingActions.js';

class ListContainer extends Component {
  static propTypes = {
    selectedMenu: PropTypes.string.isRequired,
    messages: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
    selectMessage: PropTypes.func.isRequired,
    deleteMessages: PropTypes.func.isRequired,
    toggleDrawer: PropTypes.func.isRequired,
  };

  state = {
    checked: [],
    isDelete: false,
    showModal: false,
    selectedMenu: this.props.selectedMenu,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selectedMenu !== prevState.selectedMenu)
      return {
        checked: [],
        isDelete: false,
        showModal: false,
        selectedMenu: nextProps.selectedMenu,
      };
    return prevState;
  }

  checkBoxHandler = (id, e) => {
    const checked = this.state.checked.slice();

    if (e.target.checked) {
      checked.push(id);
    } else {
      checked.splice(
        checked.findIndex(item => item === id),
        1,
      );
    }
    this.setState({ checked });
  };

  showConfirm = () => {
    this.setState({ showModal: true });
  };

  hideConfirm = () => {
    this.setState(prevState => ({ showModal: !prevState.showModal }));
  };

  editHandler = isDelete => {
    if (typeof isDelete === 'boolean') {
      this.props.deleteMessages(this.props.selectedMenu, this.state.checked, () => {
        if (typeof this.props.enqueueSnackbar === 'function') {
          this.props.enqueueSnackbar(intl.get('messaging.notifications.messageDeleted'), { variant: 'success' });
        }
      });
      this.hideConfirm();
    }
    this.setState(prevState => ({ isDelete: !prevState.isDelete, checked: [] }));
  };

  menuHandler = () => {
    this.props.toggleDrawer('left');
  };
  render() {
    return (
      <Fragment>
        {this.state.showModal && (
          <ConfirmDialog
            open
            title={intl.get('messaging.confirmDelete.title')}
            cancelText={intl.get('messaging.confirmDelete.cancel')}
            confirmText={intl.get('messaging.confirmDelete.delete')}
            onCancel={this.hideConfirm}
            onConfirm={this.editHandler.bind(this, true)}>
            <span>{intl.get('messaging.confirmDelete.messagesText')}</span>
          </ConfirmDialog>
        )}
        <ListPres
          {...this.props}
          checkBoxHandler={this.checkBoxHandler}
          isDelete={this.state.isDelete}
          editHandler={this.editHandler}
          checked={this.state.checked}
          showConfirm={this.showConfirm}
          menuHandler={this.menuHandler}
          isDefaultOldView={this.props.isDefaultOldView}
          ListContainer
          refreshUnReadMessage={this.props.refreshUnReadMessage}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  selectedMenu: state.messaging.selectedMenu,
  // messages: state.messaging.casesMessages ? state.messaging.casesMessages : getMessages(state),
  messages: ownProps.messages ? ownProps.messages : getMessages(state),
  filters: getFilters(state),
  meta: getMeta(state),
  isMobile: ownProps.isMobile,
  casesMessages: state.messaging.casesMessages,
  isComposeView: checkIsComposeView(state),
  isDraftView: checkIsDraftView(state),
  isMessagingLoading: isRequestLoading(['INBOX_LOADING', 'SENT_LOADING', 'DRAFT_LOADING'])(state),
  isFilterLoaded: state.messaging.isFilterLoaded,
  isMessageLoaded: state.messaging.isMessageLoaded,
});

const mapDispatchToProps = {
  selectMessage,
  changeSortOrder,
  deleteMessages,
  switchView,
  toggleDrawer,
  dashboardSelectMessage,
  dashboardStoreSelectedMessageId,
  resetFilterLoader,
  resetMessageLoader,
  refreshUnReadMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ListContainer));
